import { financeService } from "@/services/api/features/financialService";
import { executeAction, executeDownloadAction } from "@/services/api/helpers";

export default {
  namespaced: true,

  state: {
    loading: {},
    error: {},
  },

  getters: {
    isLoading: (state) => (action) => !!state.loading[action],
    getError: (state) => (action) => state.error[action],
  },

  mutations: {
    SET_LOADING(state, { action, status }) {
      state.loading = { ...state.loading, [action]: status };
    },
    SET_ERROR(state, { action, message }) {
      state.error = { ...state.error, [action]: message };
    },
  },
  actions: {
    async fetchFinancialByStatus({ commit }, params) {
      return executeAction({ commit, action: "fetchFinancialByStatus" }, () =>
        financeService.fetchFinancialByStatus(params)
      );
    },
    async fetchFinancialSearch({ commit }, params) {
      return executeAction({ commit, action: "fetchFinancialSearch" }, () =>
        financeService.fetchFinancialSearch(params)
      );
    },
    async fetchFinancialDetail({ commit }, orderNumber) {
      return executeAction({ commit, action: "fetchFinancialDetail" }, () =>
        financeService.fetchFinancialDetail(orderNumber)
      );
    },
    async cancelOrder({ commit }, orderId) {
      return executeAction({ commit, action: "cancelOrder" }, () =>
        financeService.cancelOrder(orderId)
      );
    },
    async confirmPayment({ commit }, payload) {
      return executeAction({ commit, action: "confirmPayment" }, () =>
        financeService.confirmPayment(payload)
      );
    },
    async confirmSendNoti({ commit }, params) {
      return executeAction({ commit, action: "confirmSendNoti" }, () =>
        financeService.confirmSendNoti(params)
      );
    },
    async getFinancialBill({ commit },orderId) {
      return executeDownloadAction({ commit, action: "getFinancialBill" }, () =>
        financeService.getFinancialBill(orderId),
        `${orderId}.pdf`
      );
    },
    async financialExport({ commit }, payload) {
      return await executeDownloadAction(
        { commit, action: "financialExport" },
        () => financeService.financialExport(payload),
        "FinancialReport.xlsx"
      );
    },
  },
};
